import { ReactNode } from 'react'

type MarginProps = {
  /** margin общий */
  m?: number
  /** margin сверху */
  mt?: number
  /** margin снизу */
  mb?: number
  /** margin слева */
  ml?: number
  /** margin справа */
  mr?: number
  /** margin слева и справа */
  mx?: number
  /** margin сверху и снизу */
  my?: number
  className?: string
  children?: ReactNode
}

export const Margin = ({ m, mt, mb, ml, mr, mx, my, className, children }: MarginProps) => {
  const margin = m ? m : mx ? `0 ${mx}px` : my ? `${my}px 0` : undefined

  const getStyle = () => {
    let styles = {}

    if (margin) {
      styles = { ...styles, margin }
    }
    if (mt) {
      styles = { ...styles, marginTop: mt }
    }
    if (mb) {
      styles = { ...styles, marginBottom: mb }
    }
    if (ml) {
      styles = { ...styles, marginLeft: ml }
    }
    if (mr) {
      styles = { ...styles, marginRight: mr }
    }
    return styles
  }

  return (
    <div style={getStyle()} className={className}>
      {children}
    </div>
  )
}
